type FilterOutRemovedValueProps = {
  currentValues: Array<any>;
  indexToRemove: number;
};

export const filterOutRemovedValue = ({
  currentValues,
  indexToRemove,
}: FilterOutRemovedValueProps) => {
  return currentValues.filter((_, i) => i !== indexToRemove);
};
